import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
interface myData {
  message: object;
  success: boolean;
}
interface user {
  ca_unit: 'CGPA' | 'CSA'
  firstname: string;
  lastname: string;
  student_id: string;
  matric_no: string;
  current_username: string;
  category: string;
  name: string;
  prog_id: number;
  tag: string;
  semester_alias: string;
  date_of_birth: string;
  email: string;
  middlename: string;
  nationality: string;
  state_of_origin: string;
  gender: string;
  address: string;
  phone_1: string;
  phone_2: string;
  rphone1_1: string;
  rfullname_1: string;
  remail_1: string;
  term: string;
  session_year: string;
  cd_id: number;
  rank?: number;
  passport: string;
  description: string;
  marital_status: string;
  term_id: number;
  termd_id: number;
  c_termd_id: number;
  branch_id: number;
  summer: string;
  class_description: string,
  cat_description: string,
  payperbyte: any,
  extra_co: any,
  reg_both_semesters: any
}

interface isLoggedIn {
  status: boolean;
}

interface logoutStatus {
  success: boolean;
}
@Injectable({
  providedIn: "root"
})
export class UserService {
  constructor (private http: HttpClient) { }

  private emitChangeSource = new BehaviorSubject<any>({ passportChanged: false });
  changeEmitted$ = this.emitChangeSource.asObservable();

  public programChange = new BehaviorSubject<any>({ st_pr_id: 0 })
  programEmitted$ = this.programChange.asObservable();
  emitChange (passport) {
    let x = { passportChanged: false };
    x.passportChanged = passport;
    this.emitChangeSource.next(x);
  }

  getUserData (): Observable<user> {
    return this.http.get<user>("/edozzier/portal-user-info.php");
  }
  billStudent (): Observable<user> {
    return this.http.get<user>("/edozzier/portal-user-info-for-billing.php");
  }

  isLoggedIn (): Observable<isLoggedIn> {
    return this.http.get<isLoggedIn>("/edozzier/portal-is-logged-in.php");
  }

  updateDetails (usr): Observable<any> {
    return this.http.post<any>(
      "/edozzier/portal-update-student-details.php",
      usr
    );
  }

  getPrograms () {
    return this.http.get<any>("/edozzier/portal-get-programs.php");
  }

  switchProgram (data) {
    return this.http.post<any>("/edozzier/portal-switch-program.php", data);
  }

  changePasscode (details) {
    return this.http.post<any>("/edozzier/portal-change-passcode.php", details);
  }

  forgotPasscode (email) {
    return this.http.post<any>("/edozzier/portal-forgot-passcode.php", email);
  }

  resetPasscode (details) {
    return this.http.post<any>("/edozzier/portal-reset-passcode.php", details);
  }

  sendCrashReport (details) {
    return this.http.post<any>("/edozzier/portal-send-crash-report.php", details);
  }

  logout () {
    return this.http.get<logoutStatus>("/edozzier/portal-logout.php");
  }
}
